<template>
  <div class="sub-album">
    <!-- 下载三张尺寸的二维码 -->
    <canvas v-show="false" class="canvasQr" width="227" height="227"  ></canvas>
    <canvas v-show="false" class="canvasQr" width="425" height="425"  ></canvas>
    <canvas v-show="false" class="canvasQr" width="850" height="850"  ></canvas>

    <div class="white-box sub-album-search column-content">
      <span class="sub-id-txt span-14">在</span>
      <el-select v-model="subSiteId" filterable placeholder="请选择">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
      <span class="sub-name-txt span-14">子站中销售</span>
      <el-input @keyup.enter.native="subsiteAlbumSearch()"  class="search-input" placeholder="请输入你想分销的专辑/声音名称" v-model="keyWord" style="width: 54%"></el-input>
      <el-button :loading="loading" @click="subsiteAlbumSearch()" type="primary" icon="search">搜索</el-button>
    </div>

    <div class="white-box sub-list" v-show="showList">
      <el-tabs v-model="activeName" type="border-card" @tab-click="tabClick">
        <el-tab-pane :label="tab.txt" v-loading="loading" :name="index.toString()" v-for="(tab,index) in tabList" :key="tab.key">
          <el-table
            :data="listData.list"
            style="width: 100%">
            <el-table-column
              prop="contentId"
              :label="activeName=='1'?'声音编号':'专辑编号'"
              width="100">
            </el-table-column>
            <el-table-column
              prop="contentName"
              :label="activeName=='1'?'声音名称':'专辑名称'"
              width="180">
            </el-table-column>
            <el-table-column
              :label="activeName=='1'?'声音封面':'专辑封面'"
              width="220">
              <template slot-scope="scope">
                <img class="cover" :src="scope.row.contentCover" width="86"/>
              </template>
            </el-table-column>
            <el-table-column
              :label="activeName=='1'?'子站声音二维码':'子站专辑二维码'"
              width="144">
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="left" v-if="hasQRcode(scope.row)">
                  <div class="preQr">
                    <p>{{ `${scope.row.contentName}` }}</p>
                    <img :src="scope.row.qrCodeUrl" />
                    <p>可使用手机扫码，查看子站在手机上的展示效果</p>
                  </div>
                  <div slot="reference" class="name-wrapper column-content qr-wrapper">
                    <img class="qrImg" :src="scope.row.qrCodeUrl" />
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              label="分销人" width="180">
              <template slot-scope="scope">
                <div :style="{color: hasQRcode(scope.row)?'':'#f66549'}">{{scope.row.ownerDesc}}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="handle"
              label="操作"
              width="180">
              <template slot-scope="scope">
                <div class="operate-button" v-if="hasQRcode(scope.row)">
                  <el-button class="copy-url" type="text" size="small" v-clipboard:copy="`${activeName=='1'?scope.row.trackUrl:scope.row.albumUrl}`" v-clipboard:success="onCopy" v-clipboard:error="onError">复制链接</el-button>
                  <el-button type="text" size="small" @click="downloadQr(scope.row.qrCodeUrl, scope.row.contentName)">保存二维码</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listData.curPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next"
        :total="listData.totalRecords">
      </el-pagination>
      <canvas id="canvas"></canvas>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { deleteEmptyObj, getFormatTime } from 'utils'
import { subsiteAlbumList, subsiteTrackList, subsiteList } from 'api'
  export default {
    data(){
      return {
        activeName: '0',
        loading: false,
        subSiteId: '',
        keyWord: '',
        pageSize: 20,
        listData: {
          list: [],
          curPage: 1,
          totalRecords: 0,
        },
        tabList: [
          {
            txt: '付费专辑',
            key: 'paidAlbum'
          },
          {
            txt: '付费声音',
            key: 'paidTrack'
          }
        ],
        getFormatTime: getFormatTime,
        options: [],
        showList: false
      }
    },
    computed: {
      ...mapGetters([
        'HOST',
        'PROTOCOL',
        'promotorType',
        'accountState'
      ])
    },
    created(){
      this.getOptions()
    },
    methods:{
      tabClick() {
        this.subsiteAlbumSearch();
      },
      hasQRcode(row) {
        return Boolean(row.albumUrl || row.trackUrl || row.qrCodeUrl);
      },
      getOptions(){
        let vis = this
        const temp = {
          "curPage": 1,
          "pageSize": 1000
        }
        subsiteList(temp).then(res=>{
          vis.loading = false
          if(res.ret == 0){
            res.data.list.forEach(subsite=>{
              const option = {
                label: subsite.subSiteName,
                value: subsite.subSiteId
              }
              vis.options.push(option)
            })
          }
        }).catch(()=>{})
      },
      handleSizeChange(){
        this.pageSize = arguments[0]
        this.subsiteAlbumSearch(1)
      },
      handleCurrentChange(){
        this.listData.curPage = arguments[0]
        this.subsiteAlbumSearch(1)
      },
      subsiteAlbumSearch(bringPag){
        let vis = this
        const temp = {
           "subSiteId": vis.subSiteId,      //子站编号  optional 与 子站名称 二选一，同时传以编号为准
           "keyWord": vis.keyWord,   //子站名称  optional 与 子站编号 二选一，同时传将被忽略
        }
        if(!/^[0-9]*[1-9][0-9]*$/.test(vis.subSiteId)){
          vis.$message({
            type:'warning',
            message:'请选择子站！'
          })
          return
        }
        if(vis.keyWord.length == 0){
          vis.$message({
            type:'warning',
            message:'请填写专辑/声音名称！'
          })
          return
        }
        if(bringPag){
          temp['curPage'] = vis.listData.curPage
          temp['pageSize'] = vis.pageSize
        }
        vis.loading = true
        // 声音/专辑
        if(vis.activeName=='1'){
          subsiteTrackList(deleteEmptyObj(temp)).then(res=>{
            vis.loading = false
            vis.showList = true
            if(res.ret ==0){
              if (res.data) {
                vis.listData = res.data
              } else {
                vis.$message({
                  type:'error',
                  message:'数据异常！'
                })
              }
            }
          }).catch(()=>{
            vis.loading = false
            vis.$message({
              type:'error',
              message:'服务异常！'
            })
          })
        } else {
          subsiteAlbumList(deleteEmptyObj(temp)).then(res=>{
            vis.loading = false
            vis.showList = true
            if(res.ret ==0){
              if (res.data) {
                vis.listData = res.data
              } else {
                vis.$message({
                  type:'error',
                  message:'数据异常！'
                })
              }
            }
          }).catch(()=>{
            vis.loading = false
            vis.$message({
              type:'error',
              message:'服务异常！'
            })
          })
        }
      },
      drawBeauty(beauty){
        let mycv = document.getElementsByClassName("canvasQr")
        for(let i=0,len=mycv.length; i<len; i++){
          let child = mycv[i]
          const width = child.width
          let myctx = child.getContext("2d");
          myctx.drawImage(beauty, 0, 0, width, width);
        }
      },
      GetUrlRelativePath(url){
        var arrUrl = url.split("//");
        var start = arrUrl[1].indexOf("/");
        var relUrl = arrUrl[1].substring(start);//stop省略，截取从start开始到结尾的所有字符
        if(relUrl.indexOf("?") != -1){
          relUrl = relUrl.split("?")[0];
        }
        return relUrl;
      },
      downloadQr(qrUrl, subName){
        let vis = this
        if(qrUrl){
          new Promise(function(resolve, reject){
            let beauty = new Image()
            beauty.setAttribute('crossOrigin', 'anonymous')
            /**
            let relativePath
            try{
              relativePath = vis.GetUrlRelativePath(qrUrl)
            }catch(err){
               reject('二维码地址有误')
            }

            console.log(relativePath)
            beauty.src = vis.PROTOCOL+vis.HOST+'/qrcode'+relativePath
            */
            beauty.src = qrUrl
            if(beauty.complete){
               vis.drawBeauty(beauty);
               resolve()
            }else{
               beauty.onload = function(){
                 vis.drawBeauty(beauty);
                 resolve()
               };
               beauty.onerror = function(error){
                console.log(error)
                reject('图片加载失败，请重试')
               };
            }
          }).then(function(value){
            let type ='png'
            let fixtype=function(type){
                type=type.toLocaleLowerCase().replace(/jpg/i,'jpeg');
                let r=type.match(/png|jpeg|bmp|gif/)[0];
                return 'image/'+r;
            }
            let savaFile=function(data,filename)
            {
                let save_link=document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
                save_link.href=data;
                save_link.download=filename;
                let event=document.createEvent('MouseEvents');
                event.initMouseEvent('click',true,false,window,0,0,0,0,0,false,false,false,false,0,null);
                save_link.dispatchEvent(event);
            }

            let d=document.getElementsByClassName("canvasQr");
            for(let i=0,len=d.length; i<len; i++){
              let child = d[i]
              let imgdata=child.toDataURL(type);
              imgdata=imgdata.replace(fixtype(type),'image/octet-stream');
              const w = child.width
              const filename=`【${subName}】二维码 - ${w}x${w}.png`
              //我想用当前秒是可以解决重名的问题了 不行你就换成毫秒
              savaFile(imgdata,filename);
            }
          }).catch( error => {
            console.log(error)
            vis.$message({
              message: error,
              type: 'error'
            });
          })
        }
      },
      onCopy: function () {
        //console.log('copy')
        this.$message({
          message: '链接复制成功',
          type: 'success'
        });
      },
      onError: function (e) {
        alert('Failed to copy texts')
      }
    }
  }
</script>

<style lang="scss" scoped>
.cover{
  vertical-align: middle;
}
.qr-wrapper{
  // height: 100px;
  //padding:15px 0;
  width: 65px;
  margin-top: 15px;
  margin-bottom: 15px;
  .qrImg{
    width: 65px;
    height: 65px;
  }
}
.preQr{
  width: 300px;
  height: 255px;
  text-align: center;
  img{
    width: 160px;
    height: 160px;
  }
}
.sub-album{
  &>div.white-box{
    width: 1050px;
  }
}
.sub-album-search{
  padding:20px 0px;
  .sub-id-txt{
    margin-left: 20px;
    margin-right: 10px;
    vertical-align: middle;
  }
  .sub-name-txt{
    margin-left: 10px;
    margin-right: 10px;
    vertical-align: middle;
  }
}
.sub-list{
  margin-top: 10px;
  height: auto;
  .title{
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    padding-left: 20px;
  }
  .operate-button{
    font-size: 12px;
    p>.el-button{
      margin-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// subAlbum.vue?5d17d47f